module.exports = __webpack_public_path__ + "img/password.126e6d42.svg";